<template>
  <div class="MyAccountMenu_Nav-desktop hide-mobile">
    <h3 class="title">{{ $t('myaccount.nav.title', 'My subscriptions') }}</h3>
    <nav class="list-unstyle">
      <router-link
        v-for="item in menuOptions"
        tag="li"
        class="nav-item"
        :to="{ path: item.route.path, query: { language: item.route.query.language } }"
        :key="item.code"
        @click.native="trackConversion({ name: 'interaction', description: `${item.analyticsCode}` })"
        :data-name="`myAccount-${item.code}`"
      >
        <a> {{ item.name }} </a>

        <span
          v-if="item.code === 'Billing' && hasOpenBalance"
          class="bubble-notification"
        >
          !
        </span>
      </router-link>
    </nav>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { detectedCulture } from '@/utilities/common/culture'

  export default {
    name: 'my-account-menu',

    data () {
      return {
        canadaLanguage: window.localStorage.getItem('canadaLanguage'),
      }
    },

    props: {
      menuOptions: {
        type: Array,
        required: true
      }
    },

    computed: {
      ...mapGetters('account', ['hasOpenBalance']),
      isCanadaSite () {
        return detectedCulture.code === 'en-ca'
      },

      queryLanguage () {
        if (this.isCanadaSite) {
          return window.localStorage.getItem('canadaLanguage')
        }
      }
    },

    created () {
      if (this.isCanadaSite && this.$route.name !== 'payment-result') {
        if (!this.queryLanguage) {
          this.$router.push({
            query: {
              language: 'en-CA'
            }
          })
        } else {
          this.$router.push({
            query: {
              language: this.queryLanguage
            }
          })
        }
        window.localStorage.setItem('canadaLanguage', this.$route.query.language)
      }
    }
  }
</script>

<style lang="scss">
  .MyAccountMenu_Nav-desktop {
    flex: 1;
    max-width: 3.04rem;
    padding: .44rem .42rem .44rem .2rem;
    background-color: $blue;

    .title {
      font-size: .21rem;
      color: $white;
      margin-bottom: .2rem;
    }

    .nav-item {
      border-bottom: .01rem solid $white;
      display: flex;
      justify-content: space-between;
      align-content: space-between;
      align-items: center;

      &:nth-last-of-type(1) {
        border-bottom: none;
      }

      > a {
        color: #bfd9e7;
        font-size: .17rem;
        font-weight: 400;
        padding: .17rem .07rem;
        display: block;
      }

      .bubble-notification {
        display: inline-flex;
        margin-right: .07rem;
      }

      &.router-link-active,
      &:hover,
      &.active {
        > a {
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
</style>
